import { render, staticRenderFns } from "./FichajeFormulario.vue?vue&type=template&id=c30aeb64&scoped=true&"
import script from "./FichajeFormulario.vue?vue&type=script&lang=ts&"
export * from "./FichajeFormulario.vue?vue&type=script&lang=ts&"
import style0 from "./FichajeFormulario.vue?vue&type=style&index=0&id=c30aeb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30aeb64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
